var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('login',{attrs:{"withenterprise":true}},[_c('v-icon',{attrs:{"slot":"eye-icon","name":"eye"},slot:"eye-icon"}),_c('v-icon',{attrs:{"slot":"eye-icon-closed","name":"eye-off"},slot:"eye-icon-closed"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }